import React from 'react';
import i18n from '../../i18n/i18n';
import { Button, TextField, Grid, IconButton, Dialog, DialogContent, DialogTitle, Typography, Checkbox, DialogContentText } from '@material-ui/core';
import { wentRight, wentWrong } from "../../utils/ToastConfig";
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import axios from '../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';

export default class NewPatch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    };

    getUser() {
        let user = localStorage.getItem('user');
        let userObject = JSON.parse(user);
        !user && window.location.replace(window.location.origin);
        return userObject;
    }

    render() {
        let user = this.getUser();
        let link = '';

        if (user.id_region === 2) {
            link = "https://manuals.agrolife.world/farmer/activities/activity/activities_rs";
        }
        else if (user.id_region === 20) {
            link = "https://manuals.agrolife.world/farmer/activities/activity/activities_rs";
        }
        else if (user.id_region === 21) {
            link = "https://manuals.agrolife.world/farmer/activities/activity/activities_rs";
        }
        else if (user.id_region === 23) {
            link = "https://manuals.agrolife.world/farmer/activities/activity/activities_rs";
        }

        else if (user.id_region === 13) {
            link = "https://manuals.agrolife.world/farmer/activities";
        }
        else if (user.id_region === 25) {
            link = "https://manuals.agrolife.world/farmer/activities";
        }
        else if (user.id_region === 26) {
            link = "https://manuals.agrolife.world/farmer/activities";
        }

        return (
            <div style={{ padding: 20 }}>
                <Dialog open={this.props.alert}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title">
                    <DialogTitle disableTypography={true} style={{ background: '#04764e' }} className="responsive-dialog-title">
                        {i18n.t('New update')}
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            <div style={{ padding: '18px 0 0 0', fontFamily: 'Roboto', fontSize: '18px', lineHeight: '26px', textAlign: 'justify' }}>
                                {i18n.t('Dear farmers')},
                                <br />
                                <br />
                                {i18n.t(' We have improved two features of our application, activities and reports')}.
                                {i18n.t(` Form for adding activities looks different now, and it's even easier to add them`)}.
                                {i18n.t(' If you add your production activities, you will be able to see')}
                                {i18n.t(' data about your production on the page Reports like the overview')}
                                {i18n.t(' of your spent materials and yields in the current season')}.
                                <br />
                                <br />
                                {i18n.t('Guides on how to use the new activities and reports can be found here')}:

                                <br /><br />
                                <a href={link} target="_blank" style={{ color: 'blue', textDecoration: 'underline' }}>
                                    {i18n.t('Guides for the new features')}
                                </a>
                                <br /> <br />
                                {i18n.t('For additional questions, you can contact us by e-mail or phone')}: <br />
                                {i18n.t('E-mail adresa')}: agrolife.podrska@gmail.com<br />
                                {i18n.t('Phone')}: 021 / 271 - 4500 <br />
                            </div>
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <Button variant='contained' color='secondary' onClick={() => {
                                    axios.get('api/season/new_feature_update');
                                    this.props.handleClose();
                                }}>{i18n.t('OK')}</Button>
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            </div >
        );
    };
};